import ShowMoreButton from './ShowMoreButton';

export default ShowMoreButton;
